import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar, { SIDEBAR_COLLAPSED_WIDTH } from './Sidebar';
import AuthGuard from '../auth/AuthGuard';

const HEADER_HEIGHT = 60;

export default function AppShell({ children }) {
  const [collapsed, setCollapsed] = useState(true);
  const layoutOffset = SIDEBAR_COLLAPSED_WIDTH;

  return (
    <div className="app-layout-shell">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((value) => !value)} />
      <Header leftOffset={layoutOffset} />

      <main
        className="app-layout-main"
        style={{
          marginLeft: layoutOffset,
          paddingTop: HEADER_HEIGHT,
        }}
      >
        <div className="app-layout-content">
          {/* Single, central auth gate: every page rendered through the shell's
              <Outlet> is guarded here. Opened without a session → the user sees
              a clear "you haven't logged in" screen instead of an empty page. */}
          <AuthGuard>
            {children ?? <Outlet />}
          </AuthGuard>
        </div>
      </main>
    </div>
  );
}
